jQuery(document).ready(function(){
	displayRightTab();
})

jQuery(window).on('hashchange', function(e){
	displayRightTab();
});

function displayRightTab() {
	jQuery('.wp-block-gutenberg-slider-tabs-tabs').each(function(){
		let currentTabs = jQuery(this);
		if(getAnchor()){
			currentTabs.find('>.tabs-container>.wp-block-gutenberg-slider-tabs-tab.active').removeClass('active');
			currentTabs.find('.tabs-menu-list>.tabs-menu-list__item.active').removeClass('active');
			currentTabs.find('>.tabs-container>#'+getAnchor()).addClass('active');
			currentTabs.find('.tabs-menu-list>div[data-tab-id='+getAnchor()+']').addClass('active');
		} else {
			let firstTabMenuItem = currentTabs.find('.tabs-menu-list>.tabs-menu-list__item').first();
			firstTabMenuItem.addClass('active');
			currentTabs.find('>.tabs-container>#'+firstTabMenuItem.attr('data-tab-id')).addClass('active');
		}
		initClick(currentTabs);
		currentTabs.addClass('loaded');
	})
}
function getAnchor() {
    var currentUrl = document.URL,
	urlParts = currentUrl.split('#');
    return (urlParts.length > 1) ? urlParts[1] : false;
}

function initClick(currentTabs){
    currentTabs.find('>.tabs-menu-list>.tabs-menu-list__item').click(function(){
        let id = jQuery(this).attr('data-tab-id');
		currentTabs.find('>.tabs-container>.wp-block-gutenberg-slider-tabs-tab.active').removeClass('active');
		currentTabs.find('.tabs-menu-list>.tabs-menu-list__item.active').removeClass('active');
		currentTabs.find('>.tabs-container>#'+id).addClass('active');
		currentTabs.find('.tabs-menu-list>div[data-tab-id='+id+']').addClass('active');
    })
}

